import { render, staticRenderFns } from "./OnlineDetails.vue?vue&type=template&id=15cabad0&"
import script from "./OnlineDetails.vue?vue&type=script&lang=js&"
export * from "./OnlineDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports